module.exports = __webpack_public_path__ + "static/img/JO.2ec80b6c.svg";